(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bamboove-mega-journal"]) return;
  try {
    
  /* Mở panel khi DI CHUỘT vào mục "Journal" ở header · đóng khi rời ra.
     Dùng uỷ quyền sự kiện ở `document` (không gắn trực tiếp vào link) vì theme
     có thể VẼ LẠI thanh menu ⇒ gắn trực tiếp là mất sự kiện. */
  (() => {
    const MQ = window.matchMedia('(min-width: 750px)');
    let panel = null;
    let link = null;
    let henAn = null;
    let dangMo = false;

    function tim() {
      panel = document.querySelector('[data-bam-mj]');
      if (!panel) return false;
      const duong = panel.dataset.blog || '/blogs/';
      link =
        [...document.querySelectorAll('header-menu a.menu-list__link, a.menu-list__link')].find((a) => {
          if (a.closest('.menu-drawer, .menu-list--mobile')) return false; // bỏ menu trong ngăn kéo
          const h = a.getAttribute('href') || '';
          return h === duong || h.startsWith(duong);
        }) || null;
      return !!link;
    }

    function datViTri() {
      const header = document.querySelector('.header');
      if (header) panel.style.top = Math.round(header.getBoundingClientRect().bottom) + 'px';
    }

    function mo() {
      clearTimeout(henAn);
      if (!MQ.matches || !panel) return;
      datViTri();
      panel.classList.add('bam-mj--mo');
      dangMo = true;
    }

    function an(cho) {
      clearTimeout(henAn);
      henAn = setTimeout(
        () => {
          if (panel) panel.classList.remove('bam-mj--mo');
          dangMo = false;
        },
        cho === undefined ? 150 : cho
      );
    }

    function trongPanel(node) {
      return !!(panel && node instanceof Node && panel.contains(node));
    }
    function trongLink(node) {
      return !!(link && node instanceof Node && link.contains(node));
    }

    document.addEventListener(
      'pointerover',
      (e) => {
        if (!MQ.matches) return;
        if (trongLink(e.target) || trongPanel(e.target)) mo();
        else if (dangMo) an();
      },
      true
    );

    document.addEventListener(
      'focusin',
      (e) => {
        if (!MQ.matches) return;
        if (trongLink(e.target) || trongPanel(e.target)) mo();
        else if (dangMo) an(0);
      },
      true
    );

    /* cuộn trang / đổi khổ ⇒ đóng */
    window.addEventListener(
      'scroll',
      () => {
        if (dangMo) an(0);
      },
      { passive: true }
    );
    window.addEventListener('resize', () => {
      if (!MQ.matches && dangMo) an(0);
    });

    /* ESC ⇒ đóng */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dangMo) an(0);
    });

    if (!tim()) {
      let dem = 0;
      const thu = setInterval(() => {
        if (tim() || ++dem > 40) clearInterval(thu);
      }, 250);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
